export default __webpack_public_path__ + "media/zurb/img/home/space-circle-office-e423423641ce152da9350be63ab32595.png";